<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <h6>Surface totale
                <p class="value">{{ favorite.square | number:'1.0-0' }} m²</p>
            </h6>
            <i class="fa fa-angle-up"></i>
            <h2>Détails des lots
                <i class="fa fa-question-circle" matTooltip="Séparez votre immeuble en plusieurs appartements, votre colocation en chambres ..."></i></h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/detailslots.PNG" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <ng-container *ngFor="let lot of favorite.lots; index as i;">
                <div class="bg-light bloc-lot row m-2 mb-3">
                    <div class="col-md-11">
                        <mat-form-field>
                            <mat-label>Nom <i class="fa fa-info-circle" matTooltip="Identifiez facilement vos lots (ex: Appartement 1er étage)"></i></mat-label>
                            <input class="text" matInput [(ngModel)]="lot.title" (ngModelChange)="edit($event, 'lot.title')">
                        </mat-form-field>
                    </div>
                    <div class="dropdown dropstart d-inline-block col-1">
                        <button class="btn btn-outline btn-tool float-right"
                                id="dropdownFav-{{i}}" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <div id="optionDropdown-{{i}}" class="dropdown-menu dropdown-menu-right"
                             aria-labelledby="dropdownFav" aria-haspopup="true" aria-expanded="false">
                            <ul class="pictoList">
                                <li>
                                    <a (click)="duplicateLot(i)">
                                        <i class="fa cfa cfa-clone"></i> Dupliquer
                                    </a>
                                </li>
                                <li *ngIf="i > 0">
                                    <a (click)="deleteLot(i)">
                                        <i class="fa cfa cfa-trash"></i>
                                        Supprimer
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field>
                            <mat-label>Superficie</mat-label>
                            <input type="number" step="10" matInput [(ngModel)]="lot.square" (ngModelChange)="edit($event)">
                            <span matSuffix>m²</span>
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field>
                            <mat-label>Type de lot</mat-label>
                            <mat-select disableOptionCentering [(ngModel)]="lot.estate_type" (ngModelChange)="edit($event)">
                                <mat-option [value]="'Maison'">Maison</mat-option>
                                <mat-option [value]="'Appartement'">Appartement</mat-option>
                                <mat-option [value]="'Chambre'">Chambre (colocation)</mat-option>
                                <mat-option [value]="'Parking'">Parking / Garage</mat-option>
                                <mat-option [value]="'Commerce'">Local commercial</mat-option>
                                <mat-option [value]="'Parties communes'">Parties communes</mat-option>
                                <mat-option [value]="'Terrain'">Terrain</mat-option>
                                <mat-option [value]="'Autres'">Autre</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field [hidden]="lot.estate_type !== 'Maison' && lot.estate_type !== 'Appartement'">
                            <mat-label>Nombre de pièces</mat-label>
                            <input type="number" step="1" matInput [(ngModel)]="lot.rooms" (ngModelChange)="edit($event)">
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
            <div class="col-md-12">
                <button (click)="addLot()" class="btn btn-outline mt-2 w-100">
                    <i class="fa fa-plus"></i><span class="libelle">Ajouter un lot</span>
                </button>
            </div>
        </div>
    </div>
</div>
